import { create } from 'zustand';

import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { getEnvironment } from 'util/urls';

import { createNodeSlice, NodeSlice } from './nodeSlice';
import { createAuthSlice, AuthSlice } from './authSlice';

export const useRoflStore = create<NodeSlice & AuthSlice>()(
    immer(
        devtools(
            ((...a) => ({
                ...createAuthSlice(...a),
                ...createNodeSlice(...a),
            })),
            { name: 'roflStore', enabled: getEnvironment() !== 'production' && process.env.NODE_ENV !== 'test' }
        )
    )
);
